module.exports = __webpack_public_path__ + "img/receipt39.e6c93349.svg";